interface Props {
  color?: string
  width?: number
  height?: number
}

export const Delete1Icon = ({ color = '#6F6F6F', width = 21, height = 22 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7578 0C15.0012 2.47159e-05 15.2097 0.175224 15.251 0.415039L15.8428 3.86816H20.3945C20.6706 3.86822 20.8944 4.09213 20.8945 4.36816C20.8945 4.64427 20.6706 4.86811 20.3945 4.86816H18.0996L17.0244 21.5322C17.0073 21.7952 16.7889 22 16.5254 22H4.36816C4.10478 21.9998 3.88625 21.7951 3.86914 21.5322L2.79395 4.86816H0.5C0.223858 4.86816 0 4.64431 0 4.36816C8.3236e-05 4.09209 0.223909 3.86816 0.5 3.86816H5.05176L5.64355 0.415039L5.66699 0.329102C5.73763 0.134559 5.92353 3.04517e-05 6.13672 0H14.7578ZM4.83691 21H16.0576L17.0977 4.86816H3.7959L4.83691 21ZM13.2109 16.5791C13.4868 16.5794 13.7109 16.8031 13.7109 17.0791C13.7108 17.355 13.4868 17.5788 13.2109 17.5791H7.68457C7.40851 17.5791 7.18471 17.3551 7.18457 17.0791C7.18457 16.803 7.40843 16.5791 7.68457 16.5791H13.2109ZM6.06738 3.86816H14.8271L14.3359 1H6.55859L6.06738 3.86816Z"
        fill={color}
      />
    </svg>
  )
}
